/* Generic MotionForm purchase links choose an activity before entering the quiz.
   Existing product selections and cart/profile editing keep their own routes. */
(function () {
  'use strict';
  var dialog = document.querySelector('[data-motion-choice]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  var opener;
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank' || link.hasAttribute('download')) return;
    var url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !/\/pages\/quiz\/?$/.test(url.pathname) || url.search || link.closest('[data-motion-choice], [data-fit-cart], [data-fit-results], [data-fit-quiz]')) return;
    event.preventDefault();
    opener = link;
    dialog.showModal();
  });
  dialog.querySelector('[data-motion-choice-close]').addEventListener('click', function () { dialog.close(); });
  dialog.addEventListener('click', function (event) { if (event.target === dialog) {
    var rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  }});
  dialog.addEventListener('close', function () { if (opener && opener.isConnected) opener.focus(); });
})();
